export default __webpack_public_path__ + "fonts/9877ea728b7d9dcf1cdc6fd2c613addb.woff";